__turbopack_context__.v({
  "blinq-logo": "BlinqTopNav-module-scss-module__T542Na__blinq-logo",
  "blinq-logo-container": "BlinqTopNav-module-scss-module__T542Na__blinq-logo-container",
});
